import * as CONS from '../../constants/urls'
import http from './httpService'

const API_ENDPOINT = `${CONS.API_ENDPOINT_EBM}/TiendaOficial`

export function buscarTodas(buscar) {
  return http.get(`${API_ENDPOINT}/BuscarTodos/${buscar}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener las tiendas.',
      tipoError: 'tiendaOficial'
    }
  })
}

export function buscarPorEmpresa(empid) {
  return http.get(`${API_ENDPOINT}/BuscarPorEmpresa/${empid}`, {
    meta: {
      toastMessage: 'Ocurrió un error al obtener la tienda.',
      tipoError: 'tiendaOficial'
    }
  })
}

export function actualizarTienda(tiendaOficial) {
  return http.put(API_ENDPOINT, tiendaOficial)
}

export function insertarTienda(tiendaOficial) {
  return http.post(API_ENDPOINT, tiendaOficial)
}

export function subirArchivo(tiendaOficial) {
  return http.post(`${API_ENDPOINT}/Upload`, tiendaOficial)
}

export function buscarImagenPorAdjunto(idTiendaOficial, idAdjunto) {
  return http.get(`${API_ENDPOINT}/BuscarImagenPorAdjunto/${idTiendaOficial}/${idAdjunto}`, {
    responseType: 'blob'
  })
}
